import { gql } from "@apollo/client";

export const GET_STUDENT_PAYMENT_PAGINATOR = gql`
  query GetStudentPaymentPagination(
    $page: Int
    $limit: Int
    $pagination: Boolean
    $schoolId: ID
    $academicYearId: ID
    $programIds: [ID]
    $classId: ID
    $studentId: ID
  ) {
    getStudentPaymentPagination(
      page: $page
      limit: $limit
      pagination: $pagination
      schoolId: $schoolId
      academicYearId: $academicYearId
      programIds: $programIds
      classId: $classId
      studentId: $studentId
    ) {
      data {
        student {
          _id
          firstName
          lastName
          englishName
          nickName
          gender
          profileImg
        }
        enrollments {
          enrollment {
            programId {
              programmName
              programmNameEn
            }
            classId {
              _id
              className
              gradeId {
                gradeName
              }
            }
          }
          invoice {
            invoiceId             
            additionalFee {
              additionalFeeTotal
              countMonth
              incomeHead {
                incomeType
                incomeHead
                _id
                note
                price
              }
              total
            }
            netAmount
            grossAmount
            discountAmount
            Amount            
          }
        }
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;
